<ng-template #announceModal let-modal>
  <div class="modal-body transport-info-body">
    <img
      *ngIf="imageUrl"
      [src]="imageUrl"
      class="transport-info-image"
      alt="transport info"
     loading="lazy" />

    <div class="modal-title transport-info-title">
      {{ title }}
    </div>

    <div
      class="transport-info-message"
      [innerHTML]="message">
    </div>

    <div class="button-box">
      <app-button
        [class]="'btn theme-bg-color btn-md fw-bold text-light transport-info-button'"
        [id]="'transport_info_ok_btn'"
        (click)="onConfirm(modal)">
        {{ buttonText || 'Đã hiểu' }}
      </app-button>
    </div>
  </div>
</ng-template>
